// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__OVVZT","active":"Breadcrumb_active__RlzXs","homeIcon":"Breadcrumb_homeIcon__uq5oy"};